// removed by extract-text-webpack-plugin
module.exports = {"actions-wrapper":"actions-wrapper"};


//////////////////
// WEBPACK FOOTER
// ./src/components/actions/Actions.scss
// module id = 5463
// module chunks = 1